import { ReasonNameInfoTooltipContent } from '@modules/common/components/ReasonNameInfoTooltipContent';
import { FormHelperText, Link, Popover } from '@mui/material';
import { useState } from 'react';

export const ReasonNameInputHelperText = () => {
  const [reasonNameInfoAnchorEl, setReasonNameInfoAnchorEl] =
    useState<HTMLElement | null>(null);
  const handleReasonNameInfoPopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    setReasonNameInfoAnchorEl(event.currentTarget);
  };

  const handleReasonNameInfoPopoverClose = () => {
    setReasonNameInfoAnchorEl(null);
  };

  const isReasonNameInfoPopoverOpen = Boolean(reasonNameInfoAnchorEl);

  return (
    <FormHelperText sx={{ ml: 0 }}>
      <Link
        component="button"
        variant="body2"
        underline="none"
        onMouseEnter={handleReasonNameInfoPopoverOpen}
        onMouseLeave={handleReasonNameInfoPopoverClose}
      >
        What makes a good name?
      </Link>
      <Popover
        id="reason-name-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={isReasonNameInfoPopoverOpen}
        anchorEl={reasonNameInfoAnchorEl}
        onClose={handleReasonNameInfoPopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <ReasonNameInfoTooltipContent />
      </Popover>
    </FormHelperText>
  );
};
